/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stop_square_medium'
export default icon
